import React, { useEffect, useState } from 'react'
import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'
import { Chip } from '@mui/material'
import { uniq } from 'lodash'

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'inline-flex',
    flexWrap: 'wrap',
  },
  item: {
    margin: theme.spacing(0.5),
  },
}))

type TagProps = {
  label: string
  checked: boolean
  onClick?: () => void
}

export const Tag: React.FC<TagProps> = ({ label, checked, onClick }) => (
  <Chip
    label={label}
    color={checked ? 'primary' : undefined}
    onClick={onClick}
  />
)

export type TextTagSelectProps = {
  values: string[]
  labels: string[]
  onChange: (labels: string[]) => void
}

const TextTagSelect: React.FC<TextTagSelectProps> = ({
  values,
  labels,
  onChange,
}: TextTagSelectProps) => {
  const { classes } = useStyles()
  const [arr, setArr] = useState<TagProps[]>([])

  useEffect(() => {
    setArr(
      uniq(labels).map((label) => {
        return { label, checked: values.includes(label) }
      })
    )
  }, [labels, values])

  const handleClick = (index: number, checked: boolean) => {
    arr[index].checked = !checked
    onChange(arr.filter(({ checked }) => checked).map(({ label }) => label))
  }

  return (
    <div className={classes.root}>
      {arr.map(({ label, checked }, index) => (
        <div key={`${index}${label}`} className={classes.item}>
          <Tag
            label={label}
            checked={checked}
            onClick={() => handleClick(index, checked)}
          />
        </div>
      ))}
    </div>
  )
}

export default TextTagSelect
